import { Route, Routes } from 'react-router-dom';

import ExercisePage from './pages/ExercisePage';
import CoursePage from './pages/CoursePage';
import CoursesPage from './pages/CoursesPage';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import InstructorDashboard from './pages/InstructorDashboard';
import InstructorChallengePage from './pages/InstructorChallengePage';
import InstructorLeaderboardPage from './pages/InstructorLeaderboardPage';
import InstructorRosterPage from './pages/InstructorRosterPage';
import ProfileSettings from './pages/ProfileSettings';
import StudentProgress from './pages/StudentProgress';
import AdminImportPage from './pages/AdminImportPage';
import InstructorBadgeRulesPage from './pages/InstructorBadgeRulesPage';
import RequireAuth from './features/auth/RequireAuth';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        path="/courses"
        element={
          <RequireAuth>
            <CoursesPage />
          </RequireAuth>
        }
      />
      <Route path="/courses/:courseId" element={<CoursePage />} />
      <Route path="/courses/:courseId/progress" element={<StudentProgress />} />
      <Route
        path="/courses/:courseId/badge-rules"
        element={
          <RequireAuth requiredRole="INSTRUCTOR">
            <InstructorBadgeRulesPage />
          </RequireAuth>
        }
      />
      <Route path="/exercise/:exerciseId" element={<ExercisePage />} />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <ProfileSettings />
          </RequireAuth>
        }
      />
      <Route
        path="/instructor"
        element={
          <RequireAuth requiredRole="INSTRUCTOR">
            <InstructorDashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/instructor/challenge"
        element={
          <RequireAuth requiredRole="INSTRUCTOR">
            <InstructorChallengePage />
          </RequireAuth>
        }
      />
      <Route
        path="/instructor/roster"
        element={
          <RequireAuth requiredRole="INSTRUCTOR">
            <InstructorRosterPage />
          </RequireAuth>
        }
      />
      <Route
        path="/courses/:courseId/leaderboard"
        element={
          <RequireAuth>
            <InstructorLeaderboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="/admin/import"
        element={
          <RequireAuth requiredRole="ADMIN">
            <AdminImportPage />
          </RequireAuth>
        }
      />
    </Routes>
  );
}

export default App;
